export default __webpack_public_path__ + "static/media/presale.a07296dd.svg";